export default "__VITE_ASSET__BGmjUO2H__"